module.exports = __webpack_public_path__ + "img/8.11d1c15a.jpg";